import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { ApiService } from 'src/app/api.service';
import { IDropdownSettings} from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-createteam',
  templateUrl: './createteam.component.html',
  styleUrls: ['./createteam.component.css']
})
export class CreateteamComponent implements OnInit {


  dropdownList = [];
  selectedItems = [];
  dropdownSettings:IDropdownSettings={};
  check_header :boolean;
  team_header_details : any;

  add_teammembers = false;
  team_details = '';

  session_list = [];
  session_count = 0;


  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  @ViewChild('agGrid2',{static:false}) agGrid2: AgGridAngular;
  TeamcolumnDefs = [
    {headerName: 'ID', field: '', width: 20, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {headerName: 'Team Name', field: 'teamname', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'status', sortable: true, filter: true},
    {headerName: 'Options', width: 120,cellRenderer: function(params) {
      return "";
    }},
  ];

  TeammemberscolumnDefs = [
    {headerName: 'ID', field: '', width: 20, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {headerName: 'Team Name', field: 'team_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Reporting to Designation', field: 'member_reporting_to_id.designation', resizable: true, sortable: true, filter: true},
    {headerName: 'Reporting to Name', field: 'member_reporting_to_id.name', resizable: true, sortable: true, filter: true},
    {headerName: 'Reporting Person Designation', field: 'member_designation_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Reporting Person Name', field: 'member_user_id.name', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'delete_status', sortable: true, filter: true},
    {headerName: 'Options', width: 120,cellRenderer: function(params) {
      return "";
    }},
  ];
  
  TeamForm: UntypedFormGroup;
  banknameList: any[];
  addmode: boolean;
  editmode: boolean;
  TeamList: any;
  fieldvisitCodeList: any;
  TeammembersForm: UntypedFormGroup;
  TeamMembersList: any;
  TeamMembersList1: any;
  Designation_details1: any[];
  Designation_details2: any[];
  user_list_details: any;
  report_to_id: any;
  User_details1: any[];
  report_to: any;
  report_to_design: any;
  company_name: any;
  Designation: any;
  memberList: any[];
  RPmemberList: any[];
  teamdataList: any;
  userFilter: any = { _id: 'New' };

  constructor(private formBuilder:UntypedFormBuilder, private _api:ApiService) { 
    this.TeamForm = this.formBuilder.group({
      _id:[''],
      teamname:['',Validators.required],
      status:['',Validators.required]
    });
    this.TeammembersForm = this.formBuilder.group({
      _id:[''],
      client_id:[''],
      bank_id:[''],
      team_name: ['', Validators.required],
      member_designation_id: ['', Validators.required],
      member_user_ids: ['', Validators.required],
      member_user_id: [''],
      member_reporting_to_id: ['', Validators.required],
      team_head : ['', Validators.required],
      delete_status: ['', Validators.required]            
    });
  }

  ngOnInit(): void {

    this.dropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.addmode = true;
    this.editmode = false;

    this._api.getlist_new_team().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TeamList = data['Data'];
        this.TeamList.sort((a, b) => {
          return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
        });
      } else {
        this.TeamList = [];
      }
    });

    this._api.getlist_new_teammembers().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TeamMembersList = data['Data'];
        this.TeamMembersList.sort((a, b) => {
          return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
        });
        this.TeamMembersList1.sort((a, b) => {
          return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
        });
        this.TeamMembersList1 = this.TeamMembersList;
        console.log(this.TeamMembersList1);
      } else {
        this.TeamMembersList = [];
      }
    });

    this._api.getlist_new_teamgroup().subscribe(data=>{
      if (data['Code'] == 200) {

        this.teamdataList.sort((a, b) => {
          return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
        });

        this.teamdataList = data['Data']
      } else {
        this.teamdataList = []
      }
    });

    
    this._api.designation_type_list().subscribe(
      (response: any) => {
        this.Designation = response.Data;
        this.Designation_details1 = [];
        this.Designation_details2 = [];
        for(let a = 0 ; a < response.Data.length; a ++){
          let x =  { 'y': response.Data[a].designation_type}
          let y =  { 'x': response.Data[a].designation_type}
          this.Designation_details1.push(x);
          this.Designation_details2.push(y);
        }
        this.Designation_details1 = this.Designation_details1.reverse();
        this.Designation_details2 = this.Designation_details2.reverse();
      }
    );
  }
  getteamdata(data){
    this.userFilter._id = data;
  }



  groupByKey(array, key) {
    return array
      .reduce((hash, obj) => {
        if(obj[key] === undefined) return hash; 
        return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
      }, {});
  }


  Report_fetch(){
    for(let a = 0 ; a < this.user_list_details.length; a ++){
      if(this.user_list_details[a].email_id == this.report_to.y){
         this.report_to_id = this.user_list_details[a]._id;
      }
    }
  }

  getbydesc(event){
    const desc = event.target.value;
    let req = {
      "bankname" : "",
      "designation" : desc
    }

    this._api.user_details_list_by_com(req).subscribe(data=>{
      if (data['Code'] == 200) {
        this.memberList = data['Data'];
      } else {
        this.memberList = [];
      }
    });
  }


  getMemberDetails(event){
    const userID = event.target.value;
    this._api.getMemberID(userID).subscribe(data=>{
      if (data['Code'] == 200) {
      } else {
      }
    });
  }

  getreporttodesc(event){
    const desc = event.target.value;
    let req = {
      "bankname" : "",
      "designation" : desc
    }

    this._api.user_details_list_by_com(req).subscribe(data=>{
      if (data['Code'] == 200) {
        this.RPmemberList = data['Data'];
        this.RPmemberList.forEach(element => {
          
        });
      } else {
        this.RPmemberList = [];
      }
    });
  }

  getreporttomember(event){
    const userID = event.target.value;
    this._api.getMemberID(userID).subscribe(data=>{
      if (data['Code'] == 200) {
      } else {
      }
    });
  }


  fetchuser_1(){

    let req = {
      "bankname" : "",
      "designation" : this.report_to_design.y
    }
    this._api.user_details_list_by_com(req).subscribe(
      (response: any) => {
        if(response.Data.length == 0){
         alert("There is no user with this designations");
        }else {
          this.User_details1 = [];
          for(let a = 0 ; a < response.Data.length; a ++){
            let x =  { 'y': response.Data[a].email_id}
            this.User_details1.push(x);
          }
          this.User_details1 = this.User_details1.reverse();
        }
      }
    );
  }



  addteam(){
    // if (this.TeamForm.valid) {
      this._api.create_new_team(this.TeamForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          alert(data['Message']);
          this.onreloadPage();
        } else {
          alert(data['Message']);
        }
      });
    // } else {
    //   alert("Please Fill all fields");
    // }
  }

  editteam(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this.addmode = false;
      this.editmode = true;
      this.TeamForm.patchValue({
        _id:selectedData[0]._id,
        teamname:selectedData[0].teamname,
        status:selectedData[0].status
      });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
    
  }

  updateteam(){
    // if (this.TeamForm.valid) {
      this._api.update_new_team(this.TeamForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          alert(data['Message']);
          this.onreloadPage();
        } else {
          alert(data['Message']);
        }
      });
    // } else {
    //   alert("Please Fill all fields");
    // }
  }

  deleteteam(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length >= 1) {
      for (let i = 0; i < selectedNodes.length; i++) {
        this._api.delete_new_team(selectedData[i]._id).subscribe(data => {
          if (data['Code'] == 200) {
            this.onreloadPage();
          } else {
            
          }
        });
      }
      
    } else {
      alert("Select atleast one Record");
    }
  }

  cancel(){
    this.addmode = true;
    this.editmode = false;
    this.TeamForm.reset();
  }

  onreloadPage(){
    this.cancel();
    this.cancelteammembers();
    this._api.getlist_new_teammembers().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TeamMembersList = data['Data'];
      } else {
        this.TeamMembersList = [];
      }
    });

    this._api.getlist_new_team().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TeamList = data['Data'];
      } else {
        this.TeamList = [];
      }
    });
  }


  addteammembers(){
    if(this.check_header == true && this.TeammembersForm.value.team_head == "true"){
      alert('This team already having team head pls select no option');
    }else{
    let data  = [];
    data = this.selectedItems;
    for(let a = 0 ; a < data.length; a++){
      this.TeammembersForm.patchValue({
        client_id:"1",
        bank_id:"1",
        member_user_id : data[a]._id,
      });
      this.TeammembersForm.value.member_user_id = data[a]._id;
       this._api.create_new_teammembers(this.TeammembersForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
        } else {
          alert(data['Message']);
        }
      });
      if(a == data.length - 1){
        alert('Add Successfully');
        this.add_teammembers = false;
        this.ngOnInit();
      }
    }  
  }
  }

  editteammembers(){
    const selectedNodes = this.agGrid2.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this.addmode = false;
      this.editmode = true;
      this.TeammembersForm.patchValue({
        _id:selectedData[0]._id,
        client_id:selectedData[0].client_id,
        bank_id:selectedData[0].bank_id,
        team_name: selectedData[0].team_name,
        member_designation_id: selectedData[0].member_designation_id,
        member_user_id: selectedData[0].member_user_id,
        member_reporting_to_id:selectedData[0].member_reporting_to_id,
        delete_status:selectedData[0].delete_status   
      });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
    
  }

  updateteammembers(){
    // if (this.TeamForm.valid) {
      this._api.update_new_teammembers(this.TeammembersForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          alert(data['Message']);
          this.onreloadPage();
        } else {
          alert(data['Message']);
        }
      });
    // } else {
    //   alert("Please Fill all fields");
    // }
  }

  deleteteammembers(datas){
    const selectedNodes = this.agGrid2.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length >= 1) {
      for (let i = 0; i < selectedNodes.length; i++) {
        this._api.delete_new_teammembers(selectedData[i]._id).subscribe(data => {
          if (data['Code'] == 200) {
     
          } else {
            alert('Try Later');
          }
        });
        if(i == selectedNodes.length - 1){
          alert('Deleted Successfully');
          this.back_action(datas);
        }
      }
      
    } else {
      alert("Select atleast one Record");
    }
  }

  cancelteammembers(){
    this.addmode = true;
    this.editmode = false;
    this.TeammembersForm.reset();
  }


  onItemSelect(item: any) {
  }

  onSelectAll(items: any) {
  }


  selectOption(data){
   this._api.fetch_new_teammembers(data).subscribe(data=>{
    if (data['Code'] == 200) {
      if(data['Data'] == null){
        this.TeammembersForm.patchValue({
          team_head:true
        });
        this.check_header = false;
      }else{
        this.TeammembersForm.patchValue({
          team_head:false
        });
        this.check_header = true;
        this.team_header_details = data['Data'];
      }
    } else {
      alert(data['Message']);
    }
  });
  }



  show_team(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
    let datas = selectedData[0].teamname;
     this._api.fetch_new_teammembers(datas).subscribe((data_value:any)=>{
      if (data_value['Code'] == 200) {
       console.log(data_value);
       if(data_value.Data == null){
        this.TeamMembersList = [];
       }else{
       this.team_details = "Team Head - " + data_value['Data'].member_reporting_to_id.name + "(" + data_value['Data'].member_reporting_to_id.designation + ")";
       let data = {
        team_name : datas,
        member_reporting_to_id: data_value['Data'].member_reporting_to_id._id
       }
       console.log(data);
      this._api.fetch_reporting_person(data).subscribe(data=>{
        this.TeamMembersList = [];
        this.TeamMembersList = data['Data'];
      });
       }
      }
    });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
  }

  back_action(data){
     if(data == 'false'){     
      this.add_teammembers = false;
      console.log(this.session_list);
      console.log(this.session_count);
      if(this.session_list.length > 0){
      let datas = this.session_list[this.session_list.length - 1];
      let data = {
        team_name : datas.team_name,
        member_reporting_to_id: datas.member_user_id._id
       }
       console.log(data);
      this._api.fetch_reporting_person(data).subscribe(data=>{
        this.TeamMembersList = [];
        this.TeamMembersList = data['Data'];
        this.session_list.splice(this.session_list.length - 1, 1);
        this.session_count = this.session_count - 1;
      });
    }else{
      this.show_team();
      alert("No Back Action");
    }
  }
  if(data == 'true'){
    this.ngOnInit()
  }
  }


  show_reporting_Person(){
    console.log(this.session_list);
    const selectedNodes = this.agGrid2.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this.session_list.push(selectedData[0]);
      this.session_count = this.session_count + 1;
       let data = {
        team_name : selectedData[0].team_name,
        member_reporting_to_id: selectedData[0].member_user_id._id
       }
       console.log(data);
      this._api.fetch_reporting_person(data).subscribe(data=>{
        this.TeamMembersList = [];
        this.TeamMembersList = data['Data'];
      });
     console.log(this.session_list); 
     this.session_list.forEach(element => {
        console.log(element.member_user_id._id);
     });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
  }

  show_forms(){
    this.add_teammembers = true;
  }

}
